export enum Subjects {
  ALL = 'all',
  DEV_TOOLS = 'dev-tools',
  ACCOUNTS = 'accounts',
  OWN_ACCOUNT = 'own-account', // This is a special case for the account admin
  ASSIGNED_ACCOUNTS = 'assigned-accounts', // This is a special case for the multiple accounts admin
  RESELLERS = 'resellers',
  RESELLERS_DOMAIN_CONFIG = 'resellers-domain-config',
  USERS = 'users',
  ROLES = 'roles',
  GROUPS = 'groups',
  BRANCHES = 'branches',
  AD_SYNC = 'ad-sync',
  FILES = 'files',
  EMAIL_TEMPLATES = 'email-templates',
  AUTO_PHISHING_CAMPAIGNS = 'auto-phishing-campaigns',
  CAMPAIGNS = 'campaigns',
  CAMPAIGNS_MIGRATION = 'campaigns-migration',
  SENDING_PROFILES = 'sending-profiles',
  PAGES = 'pages',
  ACCOUNT_CAMPAIGNS_SUMMARY = 'account-campaigns-summary',
  CAMPAIGN_RESULTS = 'campaign-results',
  ADMIN_DASHBOARD = 'admin-dashboard',
  LEARNER_DASHBOARD = 'learner-dashboard',
  SYSTEM_SETTINGS = 'system-settings',
  ME = 'me',
  COURSES = 'courses',
  ENROLLED_COURSES = 'enrolled-courses',
  ATTEMPTS = 'attempts',
  OWN_ATTEMPTS = 'own-attempts',
  COURSE_ACCOUNT_AVAILABILITY = 'course-account-availability',
  COURSE_ACCOUNT_SCHEDULES = 'course-account-schedules',
  COURSE_BRANCH_SCHEDULES = 'course-branch-schedules',
  COURSE_USER_SCHEDULES = 'course-user-schedules',
  ACCOUNT_REPORTS = 'account-reports',
  ACCOUNT_MIGRATION = 'account-migration',
  ACCOUNT_SSO = 'account-sso',
  USERS_MIGRATION = 'users-migration',
  HUBSPOT_ACCOUNT_LINK = 'hubspot-account-link',
  HUBSPOT_ERROR_LOG = 'hubspot-error-log',
  COURSE_GROUP_SCHEDULES = 'course-group-schedules',
  COURSE_FORCE_COMPLETE = 'course-force-complete',
  COURSE_PLANNER = 'course-planner',
  SECURITY_CULTURE = 'security-culture',
  SECURITY_CULTURE_REPORTS = 'security-culture-reports',
  TEST_EMAIL = 'test-email',
  FEATURE_FLAGS = 'feature-flags',
  ACCOUNT_FEATURE_FLAGS = 'account-feature-flags',
  SUPPRESSED_DOMAINS = 'suppressed-domains',
  ACCOUNT_DOMAINS = 'account-domains',
  FALSE_POSITIVE_IPS = 'false-positive-ips',
  INDIVIDUAL_AI_CAMPAIGNS = 'individual-ai-campaigns',

  // Feature
  OUTLOOK_PHISHING_EMAIL_REPORTING = 'outlook-phishing-email-reporting',
  EMAIL_OPEN_EVENTS = 'email-open-events',
  ADMIN_TASKS = 'admin-tasks',
  LEARNER_DASHBOARD_ACCESSIBILITY = 'learner-dashboard-accessibility',
  AI_PHISHING_TRAINING = 'ai-phishing-training',
  ACCOUNTS_SYSTEM_PAGE = 'accounts-system-page',
  ACCOUNT_SETTINGS_PAGE = 'account-settings-page',
  RESOURCES_PAGE = 'resources-page',
  ACCOUNT_INTERNAL_TAB = 'account-internal-tab',
  ACCOUNT_CONTENT_TAB = 'account-content-tab',
  ACCOUNT_MATERIALS_TAB = 'account-materials-tab',
  ACCOUNT_FEATURES_TAB = 'account-features-tab',
  PHISHING_SIMULATION_FOLLOW_UP = 'phishing-simulation-follow-up',
  OSINT_TRANSPARENCY = 'osint-transparency',
  IMPERSONATION = 'impersonation',
}
